document.addEventListener('DOMContentLoaded', () => {
  // DOM Elements
  const container = document.getElementById('ja-discover-now-modal-container');
  if (!container) {
    return;
  }
  const bodies = document.querySelectorAll('.ja-discover-now-modal-body');
  const discoverAccordion = document.querySelector('#modal-content-discover .ja-discover-now-modal-accordion');
  const sustainabilityAccordion = document.querySelector('#modal-content-sustainability .ja-discover-now-modal-accordion');

  const ANIMATION_DURATION = 300;
  let closeTimeout = null;
  let scrollY = 0;

  // Cache original accordion content
  if (window.originalDiscoverContent === undefined && discoverAccordion) {
    window.originalDiscoverContent = discoverAccordion.innerHTML;
  }
  if (window.originalSustainabilityContent === undefined && sustainabilityAccordion) {
    window.originalSustainabilityContent = sustainabilityAccordion.innerHTML;
  }

  // === BODY SCROLL LOCK ===
  function lockBodyScroll() {
    scrollY = window.scrollY;
    document.body.classList.add('ja-modal-locked');

    Object.assign(document.body.style, {
      overflow: 'hidden',
      touchAction: 'none'  // Prevent touch scroll
    });

    window.scrollTo(0, scrollY);
  }

  function unlockBodyScroll() {
    document.body.classList.remove('ja-modal-locked');

    Object.assign(document.body.style, {
      overflow: '',
      touchAction: ''
    });
  }

  // Make unlockBodyScroll globally accessible
  window.unlockBodyScroll = unlockBodyScroll;

  // === RUBBER-BAND SUPPRESSION (ios) ===
  let touchOpts = false;
  try {
    window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
      get: function() { touchOpts = { passive: false, capture: true }; }
    }));
  } catch (e) {}

  function suppressRubberBand() {
    document.addEventListener('touchstart', storeTouch, touchOpts || true);
    document.addEventListener('touchmove', suppressScroll, touchOpts || true);
  }

  function restoreRubberBand() {
    document.removeEventListener('touchstart', storeTouch, touchOpts || true);
    document.removeEventListener('touchmove', suppressScroll, touchOpts || true);
  }

  let firstTouchY = 0;

  function storeTouch(e) {
    firstTouchY = e.touches[0].clientY;
  }

  function suppressScroll(e) {
    let el = e.target;
    while (el && el !== document.body) {
      if (el.classList && el.classList.contains('ja-discover-now-modal-body')) {
        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;
        const currentY = e.touches[0].clientY;
        const deltaY = firstTouchY - currentY;

        const atTop = scrollTop <= 0 && deltaY < 0;
        const atBottom = scrollTop + clientHeight >= scrollHeight && deltaY > 0;

        if (!atTop && !atBottom) return; // Allow scroll inside modal
      }
      el = el.parentNode;
    }
    e.preventDefault();
  }

  // === MODAL LOGIC ===
  function showModal(type, advKey) {
    bodies.forEach(body => body.style.display = 'none');
    const target = document.getElementById(`modal-content-${type}`);
    if (target) target.style.display = 'block';

    container.classList.add('show');
    lockBodyScroll();
    suppressRubberBand();

    if (type === 'discover') {
      if (window.originalDiscoverContent !== undefined && discoverAccordion) {
        discoverAccordion.innerHTML = window.originalDiscoverContent;
      }
      if (typeof window.setupAccordion === 'function') {
        window.setupAccordion(discoverAccordion, advKey);
      }
      if (advKey) {
        container.setAttribute('data-open-adv-key', advKey);
      } else {
        container.removeAttribute('data-open-adv-key');
      }
    } else if (type === 'sustainability') {
      if (window.originalSustainabilityContent !== undefined && sustainabilityAccordion) {
        sustainabilityAccordion.innerHTML = window.originalSustainabilityContent;
      }
      if (typeof window.setupAccordion === 'function') {
        window.setupAccordion(sustainabilityAccordion, advKey);
      }
    }
  }

  function closeModal() {
    if (closeTimeout) clearTimeout(closeTimeout);
    container.classList.remove('show');
    bodies.forEach(body => body.style.display = 'none');
    unlockBodyScroll();
    restoreRubberBand();
    container.removeAttribute('data-open-adv-key');

    const modalInner = container.querySelector('.ja-discover-now-modal');
    if (modalInner) {
      modalInner.style.transition = '';
      modalInner.style.transform = '';
    }
  }

  function openModalWithContent(type, advKey) {
    if (container.classList.contains('show')) {
      closeModal();
      closeTimeout = setTimeout(() => {
        showModal(type, advKey);
      }, ANIMATION_DURATION);
    } else {
      showModal(type, advKey);
    }
  }

  // === EVENT LISTENERS ===
  const sustainabilityKeys = [
    'doga-dostu', 'geri-donusum', 'sifir-atik', 'yerel-uretim',
    'surdurulebilir-gelecek', 'tekkargo-azatik', 'elektrik-arac'
  ];

  document.body.addEventListener('click', (e) => {
    const trustItem = e.target.closest('.ja-trust-banner__item');
    const modalButton = e.target.closest('[data-modal-type]');

    if (modalButton) {
      const type = modalButton.dataset.modalType;
      openModalWithContent(type, null);
      return;
    }

    if (trustItem) {
      const advKey = trustItem.dataset.advKey;
      const type = sustainabilityKeys.includes(advKey) ? 'sustainability' : 'discover';
      openModalWithContent(type, advKey);
      return;
    }
  });

  // Close buttons (event delegation)
  container.addEventListener('click', (e) => {
    const closeSelectors = [
      '.ja-discover-now-modal-close-modal__button',
      '.ja-discover-now-modal__close',
      '.ja-discover-now-modal__continue'
    ].join(', ');

    const clickedClose = e.target.closest(closeSelectors);
    if (clickedClose) {
      closeModal();
      return;
    }

    // Click outside to close
    if (e.target === container) {
      closeModal();
    }
  });

  // ESC key close
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && container.classList.contains('show')) {
      closeModal();
    }
  });

  // === DRAG-TO-CLOSE ===
  function addDragToClose(handles) {
    if (!handles || handles.length === 0) return;

    const THRESHOLD = 150;
    let startY = 0;
    let currentY = 0;
    let dragging = false;

    handles.forEach(handle => {
      const modalInner = container.querySelector('.ja-discover-now-modal');

      handle.addEventListener('touchstart', (e) => {
        if (e.touches.length !== 1) return;
        startY = e.touches[0].clientY;
        dragging = true;
        if (modalInner) {
          modalInner.style.transition = 'none';
        }
      }, { passive: true });

      handle.addEventListener('touchmove', (e) => {
        if (!dragging) return;
        e.preventDefault();
        currentY = e.touches[0].clientY - startY;
        if (currentY > 0 && modalInner) {
          modalInner.style.transform = `translateY(${currentY}px)`;
        }
      }, { passive: false });

      handle.addEventListener('touchend', () => {
        if (!dragging) return;
        dragging = false;

        const FAST_DURATION = 180;

        if (modalInner) {
          modalInner.style.transition = `transform ${FAST_DURATION / 1000}s cubic-bezier(0.3, 0, 0.7, 1)`;
        }

        if (currentY > THRESHOLD) {
          if (modalInner) {
            modalInner.style.transform = 'translateY(100vh)';
          }
          setTimeout(() => {
            restoreRubberBand();
            closeModal();
            if (modalInner) {
              modalInner.style.transition = '';
              modalInner.style.transform = '';
            }
          }, FAST_DURATION);
        } else {
          if (modalInner) {
            modalInner.style.transform = '';
          }
        }

        startY = 0;
        currentY = 0;
      });
    });
  }

  // Attach drag handles
  const dragHandles = container.querySelectorAll(
    '.ja-discover-now-modal-close-modal__button, .ja-discover-now-modal-header, .yip-discover-now-modal-drag-wrapper'
  );
  addDragToClose(Array.from(dragHandles));
});
